var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.94421 7.90666C1.94421 8.59396 2.0951 9.12166 2.29226 9.44088C2.5508 9.85902 2.93632 10.0361 3.32944 10.0361C3.83646 10.0361 4.30031 9.91028 5.19412 8.67405C5.91025 7.6832 6.75407 6.29228 7.32178 5.42034L8.2833 3.94307C8.9512 2.91714 9.72421 1.77667 10.6106 1.00359C11.3341 0.372603 12.1147 0.0220947 12.9002 0.0220947C14.2191 0.0220947 15.4754 0.786392 16.4369 2.21985C17.4892 3.78972 18 5.76712 18 7.80773C18 9.02083 17.7609 9.91218 17.354 10.6164C16.9609 11.2975 16.1947 11.9779 14.9059 11.9779V10.0361C16.0094 10.0361 16.2849 9.02209 16.2849 7.86159C16.2849 6.20784 15.8993 4.37247 15.0499 3.06114C14.447 2.13091 13.6659 1.56257 12.8064 1.56257C11.8769 1.56257 11.1288 2.26359 10.2882 3.51374C9.84128 4.17784 9.38242 4.98721 8.86731 5.90043L8.30017 6.90513C7.1609 8.92506 6.87234 9.38512 6.30274 10.1444C5.3043 11.474 4.45183 11.9779 3.32944 11.9779C1.99807 11.9779 1.15608 11.4013 0.63471 10.5325C0.209039 9.82457 0 8.89567 0 7.83719L1.94421 7.90666Z",
    fill: "#0081FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5329 2.35689C2.42432 0.982985 3.71061 0.0220947 5.18598 0.0220947C6.04049 0.0220947 6.88986 0.275009 7.77685 0.999228C8.74702 1.79102 9.78111 3.09489 11.0712 5.24385L11.5339 6.01497C12.6505 7.87537 13.2858 8.83239 13.6576 9.2838C14.1359 9.86338 14.4708 10.0361 14.9058 10.0361C16.0094 10.0361 16.2848 9.02209 16.2848 7.86159L17.9999 7.80773C17.9999 9.02083 17.7609 9.91218 17.354 10.6164C16.9609 11.2975 16.1947 11.9779 14.9058 11.9779C14.1046 11.9779 13.3948 11.8039 12.6098 11.0633C12.0064 10.495 11.301 9.48531 10.7582 8.57765L9.14387 5.88102C8.33394 4.52772 7.59088 3.51874 7.16092 3.0617C6.6984 2.57036 6.1037 1.97692 5.15476 1.97692C4.38674 1.97692 3.73445 2.51594 3.18862 3.34028L1.5329 2.35689Z",
    fill: "url(#paint0_linear_27_862)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15475 1.97692C4.38672 1.97692 3.73443 2.51594 3.1886 3.34028C2.41685 4.50522 1.94421 6.24032 1.94421 7.90666C1.94421 8.59396 2.0951 9.12166 2.29226 9.44088L0.63471 10.5325C0.209039 9.82457 0 8.89567 0 7.83719C0 5.91231 0.528328 3.90616 1.53295 2.35689C2.42437 0.982985 3.71067 0.0220947 5.18604 0.0220947L5.15475 1.97692Z",
    fill: "url(#paint1_linear_27_862)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27_862",
    x1: 230.062,
    y1: 668.758,
    x2: 1467.98,
    y2: 731.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0073EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_27_862",
    x1: 281.68,
    y1: 870.098,
    x2: 281.68,
    y2: 413.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeta);
export default __webpack_public_path__ + "static/media/meta.c2b0abfd50ed43d08506eb54f60a7f76.svg";
export { ForwardRef as ReactComponent };